import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Group, TextInput, Button, Pagination, Modal, ScrollArea, Drawer, Badge } from '@mantine/core'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllBrandList, deleteDataBrand } from '../../../../services/brands'
import { useDebouncedCallback } from '@mantine/hooks'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableBrands from '../../../../component/pages/Brands/TableBrands'
import FormBrands from '../../../../component/pages/Brands/FormBrands'
import FormFilterBrands from '../../../../component/pages/Brands/FormFilterBrands'
import { modalDeleteData } from '../../../../component/ui/Prompt/modalDeleteData'
import FormCategories from '../../../../component/pages/Brands/FormCategories'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 15,
  sort: '-id',
  include: 'suppliers,brand_distributor,countries,categories,user',
}

const labelTable = [
  {
    label: 'ID',
    width: 30
  },
  {
    label: 'Brand Name',
    width: 200
  },
  {
    label: 'Brand Country',
    width: 180
  },
  {
    label: 'Principal',
    width: 100
  },
  {
    label: 'Distributed to country',
    width: 'auto'
  },
  {
    label: 'Imported',
    width: 100
  },
  {
    label: 'Partnered',
    width: 100
  },
  {
    label: 'Featured',
    width: 100
  },
  {
    label: 'Category',
    width: 200
  },
  {
    label: 'Status',
    width: 100
  },
  {
    label: 'Action',
    width: 50
  },
]

const BrandList = () => {
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [brandList, setBrandList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [openModalCategories, setOpenModalCategories] = useState(false)
  const [openModalFilter, setOpenModalFilter] = useState(false)
  const [detailData, setDetailData] = useState(null)


  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Product',
      route: null
    },
    {
      label: 'Brands',
      route: null
    },
  ]

  const handleGetAllBrandList = useDebouncedCallback(async () => {
    setLoading(true)
    try {
      const response = await getAllBrandList(params)
      if (response.success) {
        const dataBrand = response.data
        const brandIncluded = response.included
        const countData = response.meta.pagination.total

        const handleGetCategories = (category) => {
          if (category.length > 0) {
            return brandIncluded.categories[category[0].id].attributes
          } else {
            return null
          }
        }

        const handleGetDistributionCountry = (distributorBrand) => {
          if (distributorBrand.length > 0) {
            const remapData = distributorBrand.map((val) => {
              const remap = {
                id: brandIncluded.brand_distributor[val.id].attributes.id,
                name: brandIncluded.brand_distributor[val.id].attributes.name,
              }
              return remap
            }) 
            return remapData
          } else {
            return []
          }
        }

        const handleGetSuppliers = (supplier) => {
          if (supplier.length > 0) {

            const remapData = supplier.map((val) => {
              const remap = {
                id: brandIncluded.suppliers[val.id].attributes.id,
                name: brandIncluded.suppliers[val.id].attributes.name,
                is_primary: brandIncluded.suppliers[val.id].attributes.pivot.is_primary,
              }
              return remap
            }) 
            return remapData
          } else {
            return []
          }
        }

        const remapBrand = dataBrand.map((val) => {
          const remap = {
            id: val.attributes.id,
            name: val.attributes.name,
            status: val.attributes.active,
            website: val.attributes.website,
            image_url: val.attributes.image_url,
            featured: val.attributes.featured,
            principal_brand: Boolean(val.attributes.principal_brand),
            is_import: val.attributes.is_import,
            is_partnered: val.attributes.is_partnered,
            description: val.attributes.description,
            user_id: val.attributes.user_id,
            open_distributor_country: handleGetDistributionCountry(val.relationships.brand_distributor),
            country: val.attributes.country.name,
            country_id: val.attributes.country.id,
            suppliers: handleGetSuppliers(val.relationships.suppliers),
            categories: handleGetCategories(val.relationships.categories),
            slug: val.attributes.slug,
            export_minimum_value: val.attributes.export_minimum_value,
            export_currency: val.attributes.export_currency,
            priority: val.attributes.priority
          }
          return remap
        })

        setBrandList(remapBrand)
        setTotalData(countData)
      } else {
        setBrandList([])
        setTotalData(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, 500)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line 
  }, [dispatch])

  useEffect(() => {
    handleGetAllBrandList()
    // eslint-disable-next-line
  }, [params])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    editCategory: (val) => {
      setDetailData(val)
      setOpenModalCategories(true)
    },
    delete: (val) => {
      modalDeleteData('Brand', val.id, val.name, deleteDataBrand, handleGetAllBrandList)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const handleChangeFilter = (name, val) => {
    setParams((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    setParams((oldVal) => ({ ...oldVal, ...params }))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
    setOpenModalCategories(false)
    setDetailData(null)
  }

  const onCloseFormFilter = () => {
    setOpenModalFilter(false)
  }

  const mappingFilterBrand = (parameter) => {
    if (parameter['filter[active][is]'] || parameter['filter[principal_brand][is]'] || parameter['filter[featured][is]'] || parameter['filter[statuses.id][is]'] || parameter['filter[is_import][is]'] || parameter['filter[is_partnered][is]'] || parameter['filter[countries.id][is]']) {
      return (
        <Box>
          <Group gap='sm' align='center' mb={12}>
            {parameter['filter[active][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Status: {parameter['filter[active][is]'] === '1' ? 'Active' : 'Inactive'}</Badge> : ''}
            {parameter['filter[principal_brand][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Principal Brand: {parameter['filter[principal_brand][is]'] === '1' ? 'Yes' : 'No'}</Badge> : ''}
            {parameter['filter[featured][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Featured: {parameter['filter[featured][is]'] === '1' ? 'Yes' : 'No'}</Badge> : ''}
            {parameter['filter[is_import][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Imported Brand: {parameter['filter[is_import][is]'] === '1' ? 'Yes' : 'No'}</Badge> : ''}
            {parameter['filter[is_partnered][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Is Partnered: {parameter['filter[is_partnered][is]'] === '1' ? 'Yes' : 'No'}</Badge> : ''}
            {parameter['filter[countries.id][is]'] ? <Badge variant="light" color="black" tt='capitalize' fw='500'>Country ID: {parameter['filter[countries.id][is]']}</Badge> : ''}
          </Group>
          <Group align='center' gap='sm'>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setOpenModalFilter(true)}>Modify Filter</Button>
            <Button size='compact-sm' fz={11} fw='500' variant="outline" onClick={() => setParams(defaultParameter)}>Clear Filter</Button>
          </Group>
        </Box>
      )
    }
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Brand</Text>
            <Group gap='sm' align='center'>
              <TextInput
                value={params['filter[name][like]']}
                placeholder='Search by name'
                onChange={(val) => {
                  handleChangeFilter('filter[name][like]', val.target.value)
                  handleChangePage(1)
                }}
                size='xs'
              />
              <Button size='xs' variant="outline" onClick={() => setOpenModalFilter(true)}>Filter</Button>
              <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add New Brand</Button>
            </Group>
          </Flex>
        </Box>
        {mappingFilterBrand(params)}
        <Box my={30}>
          <Group mb={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{totalData} Brands </Text>
          </Group>
          {loading ? <LoadingData /> : brandList.length > 0 ? <TableBrands label={labelTable} data={brandList} actionMethod={handleAction}  /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Drawer position='right' title='Filter Brand' opened={openModalFilter} onClose={onCloseFormFilter} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormFilterBrands paramsBrands={params} applyFilter={handleApplyFilter} onClose={onCloseFormFilter} />
      </Drawer>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData === null ? 'Add' : 'Update'} Brand</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <FormBrands dataBrand={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetAllBrandList} />
      </Modal>
      <Modal opened={openModalCategories} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='xl' title={<Text fw='Bold'>{detailData?.categories === null ? 'Add' : 'Edit'} Brand Category</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false} zIndex={200}>
        <FormCategories dataBrand={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetAllBrandList} />
      </Modal>
    </AuthLayout>
  )
}

export default BrandList